module.exports = __webpack_public_path__ + "static/media/11.d9158be7.jpg";